let loaded = false;

/**
 * Your UTMify pixel ID.
 *
 * Leave this as an empty string until you paste the real ID from your UTMify
 * dashboard (Settings → Pixel). The pixel script resolves this ID against
 * UTMify's API on load, so an invalid/placeholder ID makes it throw
 * ("undefined is not an object (evaluating '...lead._id')").
 *
 * The UTM parameter tracker below does not require an ID and always loads.
 */
const UTMIFY_PIXEL_ID = '';

function injectScript(src: string, attrs: Record<string, string> = {}) {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.defer = true;
  Object.entries(attrs).forEach(([key, value]) =>
    script.setAttribute(key, value),
  );
  document.head.appendChild(script);
}

/**
 * Loads the official UTMify scripts.
 * Safe to call multiple times — the scripts are only injected once.
 */
export function loadUtmify(): void {
  if (loaded || typeof document === 'undefined') return;
  loaded = true;

  // --- UTMify UTM tracker (no pixel ID required) ---
  injectScript('https://cdn.utmify.com.br/scripts/utms/latest.js', {
    'data-utmify-prevent-xcod-sck': '',
    'data-utmify-prevent-subids': '',
  });

  // --- UTMify Pixel (only with a real pixel ID) ---
  if (!UTMIFY_PIXEL_ID) return;

  (window as unknown as Record<string, unknown>).pixelId = UTMIFY_PIXEL_ID;
  injectScript('https://cdn.utmify.com.br/scripts/pixel/pixel.js');
}
